<template>
  <header class="mobile-header">
    <div class="logo">
      <img src="../assets/images/logo.png" alt="Logo">
    </div>
<!--    <div class="menu-icon" @click="toggleMenu">
      <div class="sandwich"></div>
    </div>-->
<!--    <button class="menu" @click="toggleMenu" aria-label="Main Menu">
      <svg width="100" height="100" viewBox="0 0 100 100">
        <path class="line line1" d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058" />
        <path class="line line2" d="M 20,50 H 80" />
        <path class="line line3" d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942" />
      </svg>
    </button>-->
    <button
        class="menu"
        :class="{ opened: isMenuOpen }"
        @click="toggleMenu"
        :aria-expanded="isMenuOpen"
        aria-label="Main Menu"
    >
      <svg width="100" height="100" viewBox="0 0 100 100">
        <path class="line line1" d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058" />
        <path class="line line2" d="M 20,50 H 80" />
        <path class="line line3" d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942" />
      </svg>
    </button>

    <div class="overlay" v-if="isMenuOpen">
      <div class="overlay-content">
<!--        <div class="close-icon" @click="toggleMenu">×</div>-->
        <nav class="bg-color">
          <ul>
            <li>
              <a @click="scrollTo('transfer')">{{ $t('headerNav.transfer') }}</a>
            </li>
            <li>
              <a @click="scrollTo('tours')">{{ $t('headerNav.tours') }}</a>
            </li>
            <li>
              <a @click="scrollTo('carRent')">{{ $t('headerNav.carRent') }}</a>
            </li>
            <li>
              <a @click="scrollTo('limo')">{{ $t('headerNav.limoService') }}</a>
            </li>
          </ul>
        </nav>
        <div class="header__top__lang">
          <CustomDropdown></CustomDropdown>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import CustomDropdown from "@/components/CustomDropdown.vue";

export default {
  name: 'MobileHeader',
  components: {CustomDropdown},
  data() {
    return {
      isMenuOpen: false
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (this.isMenuOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    scrollTo(sectionId) {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }

      // Zatvori meni nakon klika
      this.isMenuOpen = false;
      document.body.style.overflow = ''; // Vrati normalno skrolovanje
    },
    handleScroll() {
      const currentScrollY = window.scrollY;
      if (currentScrollY > this.lastScrollY) {
        // Scrolling down
        this.isHeaderHidden = true;
      } else {
        // Scrolling up
        this.isHeaderHidden = false;
      }
      this.lastScrollY = currentScrollY;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/main.scss";

.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: $primary-blue;
  color: #fff;

  .logo img {
    width: 60px;
  }

  .menu-icon {
    display: flex;
    align-items: center;
    cursor: pointer;

    .sandwich {
      width: 30px;
      height: 2px;
      background-color: #fff;
      position: relative;
      transition: transform 0.3s ease;

      &::before,
      &::after {
        content: '';
        width: 30px;
        height: 2px;
        background-color: #fff;
        position: absolute;
        transition: transform 0.3s ease;
      }

      &::before {
        top: -8px;
      }

      &::after {
        top: 8px;
      }
    }
  }

  .menu {
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    padding: 0;
    height: 50px;
    z-index: 1111;
    svg {
      height: 50px;
    }
  }
  .line {
    fill: none;
    stroke: white;
    stroke-width: 6;
    transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
    stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  .line1 {
    stroke-dasharray: 60 207;
    stroke-width: 6;
  }
  .line2 {
    stroke-dasharray: 60 60;
    stroke-width: 6;
  }
  .line3 {
    stroke-dasharray: 60 207;
    stroke-width: 6;
  }
  .opened .line1 {
    stroke-dasharray: 90 207;
    stroke-dashoffset: -134;
    stroke-width: 6;
  }
  .opened .line2 {
    stroke-dasharray: 1 60;
    stroke-dashoffset: -30;
    stroke-width: 6;
  }
  .opened .line3 {
    stroke-dasharray: 90 207;
    stroke-dashoffset: -134;
    stroke-width: 6;
  }


}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #232438ed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .overlay-content {
    text-align: center;
    color: #fff;
    .bg-color {
      background-color: transparent !important;
    }
    nav ul {
      list-style: none;
      padding: 0;
      display: flex;
      flex-direction: column;

      li {
        margin: 20px 0;

        a {
          color: #fff;
          text-decoration: none;
          font-size: 1.5rem;
          transition: color 0.3s ease;

          &:hover {
            color: $primary-blue;
          }
        }
      }
    }
  }
}
::v-deep {
  .dropdown-button {
    background-color: transparent !important;
  }
}
</style>
